module.exports = __webpack_public_path__ + "static/media/9.b55091c3.jpg";